import { render } from "./PriceList.vue?vue&type=template&id=61d6cc14&scoped=true"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"

import "./PriceList.vue?vue&type=style&index=0&id=61d6cc14&scoped=true&lang=css"
import "./PriceList.vue?vue&type=style&index=1&id=61d6cc14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d6cc14"]])

export default __exports__